module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/back-speed-guest-4117e231c851e4e1462fb356df907bc5.jpg";